import React from "react";
import {IonAlert, IonButton, IonIcon} from "@ionic/react";
import {trash} from "ionicons/icons";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    onClick: () => void;
    confirmationContent?: string;
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 31/05/2022
 * @last_update 31/05/2022
 **/
class DeleteButton extends React.Component<Props> {

    state = {
        isAlertConfirmDeleteOpen: false,
    }

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        const deleteConfirmButtons = [
            {
                text: getTranslation("pages.map.marker.modal.action-buttons.delete.alert.cancel"),
                role: 'cancel',
            },
            {
                text: getTranslation("pages.map.marker.modal.action-buttons.delete.alert.validate"),
                handler: () => {
                    this.props.onClick();
                    window.location.reload();
                }
            }
        ];

        return (
            <div>
                <IonButton color="danger" expand="block" onClick={() => this.setState({isAlertConfirmDeleteOpen: true})} id="displayInstallDeleteButton">
                    <IonIcon icon={trash} slot="start"/>
                    {getTranslation("pages.map.marker.modal.action-buttons.delete.button")}
                </IonButton>
                <IonAlert
                    isOpen={this.state.isAlertConfirmDeleteOpen}
                    onDidDismiss={() => this.setState({isAlertConfirmDeleteOpen: false})}
                    header={getTranslation("pages.map.marker.modal.action-buttons.delete.alert.title")}
                    message={this.props.confirmationContent}
                    buttons={deleteConfirmButtons}
                    id="displayInstallIonAlert"
                />
            </div>
        );
    }

}

export default withTranslation()(DeleteButton);
